"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalStorage = void 0;
const utils_1 = require("../../utils");
class GlobalStorage {
    constructor(arcxLogger, globalsCollection) {
        this.arcxLogger = arcxLogger;
        this.globalsCollection = globalsCollection;
    }
    // There will only ever be a single global per network
    readGlobals(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const globals = (yield this.globalsCollection[(0, utils_1.getNetworkGroup)(chainId)].findOne());
                return globals;
            }
            catch (error) {
                const errMessage = `GlobalStorage::readGlobals => Could not find globals: ${error}`;
                this.arcxLogger.error(errMessage);
                throw Error(errMessage);
            }
        });
    }
    updateGlobals(chainId, attributes) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const latestGlobals = yield this.readGlobals(chainId);
                delete attributes._id;
                const updatedGlobals = yield this.globalsCollection[(0, utils_1.getNetworkGroup)(chainId)].updateOne({ _id: latestGlobals._id }, { $set: attributes });
                return updatedGlobals.acknowledged;
            }
            catch (error) {
                this.arcxLogger.warning(`GlobalStorage::updateGlobals => ${error}`);
                return false;
            }
        });
    }
    deleteGlobalsBefore(chainId, epoch) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const deletedGlobals = yield this.globalsCollection[(0, utils_1.getNetworkGroup)(chainId)].deleteMany({
                    current_epoch: { $lt: epoch },
                });
                return deletedGlobals.acknowledged;
            }
            catch (error) {
                this.arcxLogger.error(`GlobalStorage::deleteGlobalsBefore => ${error}`);
                return false;
            }
        });
    }
}
exports.GlobalStorage = GlobalStorage;
//# sourceMappingURL=GlobalStorage.js.map